import { gql } from '@apollo/client';

const PROJECT_QUERY = gql`
  query ProjectQuery($projectId: ID!) {
    currentUser {
      admin
      userProject(id: $projectId) {
        __typename
        id
        name
        hostnames
        devurl
        feedbackUrl
        allowEmailTasks
        allowEmailComments
        allowGuestsViewCommits
        assignGuests
        shortcutToShowWidget
        toggleVerticalPosition
        guestPermission
        apiKey
        isPublic
        organizationId
        basicAuthUsername
        basicAuthPassword
        ignoredQuerystrings
        allowProjectSummaryEmail
        javascriptInstalledOverride
        allowTaskDoneEmail
        acceptingFeedback
        acceptingFeedbackEndDate
        organization {
          acceptingFeedbackAllowed
          feedbackDeadlineAllowed
          id
        }
        owner {
          __typename
          id
          email
          name
        }
        membersOnProject {
          __typename
          id
          email
          name
        }
        showNewSidebar
        experiments
        createTagsViaNewTask
        allowGuestsChangeTaskStatus
        allowProjectOwnerNotifications
        changeGuestDefaultColumn
        guestDefaultColumnId
        aiSuggestedTags
        aiSuggestedTitles
        aiDuplicateTasks
        aiSuggestedTagsExistingOnly
        aiSuggestedTitlesDefaultLanguage
        orgAiSuggestedTags
        orgAiSuggestedTitles
        orgAiDuplicateTasks
        columns {
          __typename
          id
          name
          firstColumn
        }
        orgAiSuggestedTagsExistingOnly
        orgAiSuggestedTitlesDefaultLanguage
        sites {
          __typename
          id
          url
        }
      }
    }
  }
`;

const UPDATE_PROJECT = gql`
  mutation UpdateProject(
    $projectId: ID!
    $name: String
    $allowEmailComments: Boolean
    $allowEmailTasks: Boolean
    $allowProjectOwnerNotifications: Boolean
    $changeGuestDefaultColumn: Boolean
    $guestDefaultColumnId: ID
    $ownerId: ID
    $guestPermission: String
    $isPublic: Boolean
    $shortcutToShowWidget: String
    $toggleVerticalPosition: Int
    $basicAuthUsername: String
    $basicAuthPassword: String
    $ignoredQuerystrings: [String!]
    $showNewSidebar: Boolean
    $createTagsViaNewTask: Boolean
    $acceptingFeedback: Boolean
    $acceptingFeedbackEndDate: ISO8601DateTime
    $aiSuggestedTags: Boolean
    $aiSuggestedTitles: Boolean
    $aiDuplicateTasks: Boolean
    $aiSuggestedTagsExistingOnly: Boolean
    $aiSuggestedTitlesDefaultLanguage: String
  ) {
    updateProject(
      input: {
        projectId: $projectId
        name: $name
        allowEmailComments: $allowEmailComments
        allowEmailTasks: $allowEmailTasks
        allowProjectOwnerNotifications: $allowProjectOwnerNotifications
        changeGuestDefaultColumn: $changeGuestDefaultColumn
        guestDefaultColumnId: $guestDefaultColumnId
        ownerId: $ownerId
        guestPermission: $guestPermission
        isPublic: $isPublic
        shortcutToShowWidget: $shortcutToShowWidget
        toggleVerticalPosition: $toggleVerticalPosition
        basicAuthUsername: $basicAuthUsername
        basicAuthPassword: $basicAuthPassword
        ignoredQuerystrings: $ignoredQuerystrings
        showNewSidebar: $showNewSidebar
        createTagsViaNewTask: $createTagsViaNewTask
        acceptingFeedback: $acceptingFeedback
        acceptingFeedbackEndDate: $acceptingFeedbackEndDate
        aiSuggestedTags: $aiSuggestedTags
        aiSuggestedTitles: $aiSuggestedTitles
        aiDuplicateTasks: $aiDuplicateTasks
        aiSuggestedTagsExistingOnly: $aiSuggestedTagsExistingOnly
        aiSuggestedTitlesDefaultLanguage: $aiSuggestedTitlesDefaultLanguage
      }
    ) {
      project {
        __typename
        id
        name
        allowEmailComments
        allowEmailTasks
        allowProjectOwnerNotifications
        changeGuestDefaultColumn
        guestDefaultColumnId
        ownerId
        guestPermission
        isPublic
        shortcutToShowWidget
        toggleVerticalPosition
        basicAuthUsername
        basicAuthPassword
        ignoredQuerystrings
        showNewSidebar
        experiments
        createTagsViaNewTask
        acceptingFeedback
        acceptingFeedbackEndDate
        aiSuggestedTags
        aiSuggestedTitles
        aiDuplicateTasks
        aiSuggestedTagsExistingOnly
        aiSuggestedTitlesDefaultLanguage
      }
    }
  }
`;

export { PROJECT_QUERY, UPDATE_PROJECT };
